import { useMemo } from "react";
import {
  buildCycleSpendBreakdown,
  buildDiscretionaryBudgetPressure,
} from "@/domains/analytics/utils/cycleSpendBreakdown";
import { useTransactionTypes, useTransactions } from "@/hooks/useTransactions";

type CategoryLike = { id: number; name: string };
type BudgetLike = { category_id?: number | null; amount?: number };

export const useCycleSpendBreakdown = (
  cycleRange: { start: string; end: string },
  budgets: BudgetLike[],
  categories: CategoryLike[],
) => {
  const transactions = useTransactions({
    billable_date_gte: cycleRange.start,
    billable_date_lte: cycleRange.end,
  });
  const transactionTypes = useTransactionTypes();

  const breakdown = useMemo(
    () => buildCycleSpendBreakdown(transactions.data ?? [], transactionTypes.data ?? []),
    [transactions.data, transactionTypes.data],
  );

  const budgetPressure = useMemo(
    () => buildDiscretionaryBudgetPressure(breakdown.discretionaryByCategory, budgets, categories),
    [breakdown.discretionaryByCategory, budgets, categories],
  );

  return {
    breakdown,
    budgetPressure,
    isLoading: transactions.isLoading || transactionTypes.isLoading,
    isError: transactions.isError || transactionTypes.isError,
  };
};
